<template>
  <section id="realisations">
    <section
      id="realisations">
      <v-parallax
        src="fond10_noblur.jpg"
        height="380"
        top
        class="gradienthero">
        <v-overlay
          :absolute="true"
        >
          <v-layout
            column
            align-center
            justify-center>
            <div class="display-2 font-weight-bold white--text mb-4 text-center text-uppercase">Nos réalisations</div>
            <em>Découvrez nos dernières réalisations pour particuliers et professionnels</em>
          </v-layout>
        </v-overlay>
      </v-parallax>
    </section>

    <section>
      <v-container
        grid-list-xl
        fluid>
        <v-layout
          wrap
          justify-center
          class="my-3">
          <v-flex
            sm12>
            <v-card-text
              class="text-center">
              Découvrez nos dernières réalisations de plafonds et murs tendus pour nos clients particuliers et professionnels.
            </v-card-text>
          </v-flex>
          <v-flex
            v-for="(realisation, k) in orderBy(realisations, 'creation')"
            v-if="realisation.publie"
            :key="k"
            sm4
            class="align-self-start">
            <v-card
              height="100%"
            >
              <v-carousel
                :interval="5000"
                cycle
                hide-delimiter-background
                height="250"
              >
                <v-carousel-item
                  v-for="(slide, i) in realisation.gallerie"
                  :key="i"
                >
                  <v-sheet
                    color="white"
                    height="100%"
                    tile
                  >
                    <v-row
                      class="fill-height"
                      align="center"
                      justify="center"
                    >
                      <viewer :options="optionszoom">
                        <img
                          :src="slide"
                          height="350px">
                      </viewer>
                    </v-row>
                  </v-sheet>
                </v-carousel-item>
              </v-carousel>
              <v-card-title>{{ realisation.titre }}</v-card-title>
              <v-card-text>
                <div class="my-1 subtitle-3">
                  {{ formatedDate(realisation.date) }}
                </div>
                <div v-html="realisation.contenu"/>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
  </section>
</template>

<script>
import {
  mapGetters,
  mapActions
} from 'vuex'
import Vue2Filters from 'vue2-filters'
import moment from 'moment'

export default {
  mixins: [Vue2Filters.mixin],
  data () {
    return {
      optionszoom: {
        'inline': false,
        'button': true,
        'navbar': false,
        'title': false,
        'toolbar': false,
        'tooltip': false,
        'movable': false,
        'zoomable': true,
        'rotatable': false,
        'scalable': false,
        'transition': false,
        'fullscreen': false,
        'keyboard': false,
        'url': 'data-source'
      }
    }
  },
  computed: {
    ...mapGetters(['realisations'])
  },
  created () {
    this.$store.dispatch('bindRealisations')
  },
  methods: {
    ...mapActions(['showModal']),
    formatedDate (datetoformat) {
      return moment(datetoformat).format('DD/MM/YYYY')
    },
    activezoom (imgtopass) {
      this.$store.dispatch('fetchSelectedImgzoom', imgtopass)
      this.showModal('Zoomimg')
    }
  }
}
</script>

<style lang="scss">
.v-window__prev{
  width: 41px;
  height: 41px;
  .v-btn{
    width: 41px;
    height: 41px;
    margin: 0 0 0 0 !important;
  }
}
.v-window__next{
  width: 41px;
  height: 41px;
  .v-btn{
    width: 41px;
    height: 41px;
    margin: 0 0 0 0 !important;
  }
}
</style>
